import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { toGetFetchSfWaybills, toGetFetchSfWaybills2, toGetRoute, toUpdateList } from '@/api/correspondence/task/form';
import { transformInputCodes } from '@/util';
export default {
  name: 'data-list',
  data: function data() {
    return {
      codes: '',
      loading: false,
      direction: 1,
      errorCodes: [],
      successCodes: []
    };
  },
  computed: {
    dataCodes: function dataCodes() {
      var codes = this.codes;
      return transformInputCodes(codes);
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(_this.dataCodes.length > 10)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, _this.$message.warning('每次至多10条数据'));
            case 1:
              _this.errorCodes = [];
              _this.successCodes = [];
              _this.loading = true;
              _context.n = 2;
              return _this.$awaitTo(toGetFetchSfWaybills({
                confirmcodes: _this.dataCodes,
                direction: _this.direction
              }));
            case 2:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              _this.loading = false;
              if (!err) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              if (Array.isArray(data) && data.length > 0) {
                _this.errorCodes = _this.dataCodes.filter(function (item) {
                  return !data.includes(item);
                });
                _this.successCodes = _this.dataCodes.filter(function (item) {
                  return data.includes(item);
                });
              } else {
                _this.errorCodes = _this.dataCodes;
              }
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    submit2: function submit2() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(_this2.dataCodes.length > 1)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, _this2.$message.warning('回函面单查询仅支持单条查询'));
            case 1:
              _this2.errorCodes = [];
              _this2.successCodes = [];
              _this2.loading = true;
              _context2.n = 2;
              return _this2.$awaitTo(toGetFetchSfWaybills2(_this2.dataCodes.join('')));
            case 2:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              _this2.loading = false;
              if (!err) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2);
            case 3:
              if (Array.isArray(data) && data.length > 0) {
                _this2.errorCodes = _this2.dataCodes.filter(function (item) {
                  return !data.includes(item);
                });
                _this2.successCodes = _this2.dataCodes.filter(function (item) {
                  return data.includes(item);
                });
              } else {
                _this2.errorCodes = _this2.dataCodes;
              }
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    update: function update() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(_this3.dataCodes.length > 10)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, _this3.$message.warning('每次至多10条数据'));
            case 1:
              _this3.errorCodes = [];
              _this3.successCodes = [];
              _this3.loading = true;
              _context3.n = 2;
              return _this3.$awaitTo(toUpdateList(_this3.dataCodes));
            case 2:
              _yield$_this3$$awaitT = _context3.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 2);
              err = _yield$_this3$$awaitT2[0];
              data = _yield$_this3$$awaitT2[1];
              _this3.loading = false;
              if (!err) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              _this3.$message.success('操作成功');
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getRoute: function getRoute() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(_this4.dataCodes.length > 10)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, _this4.$message.warning('每次至多10条数据'));
            case 1:
              _this4.loading = true;
              _this4.errorCodes = [];
              _this4.successCodes = [];
              _context4.n = 2;
              return _this4.$awaitTo(toGetRoute({
                confirmcodes: _this4.dataCodes,
                direction: _this4.direction
              }));
            case 2:
              _yield$_this4$$awaitT = _context4.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 2);
              err = _yield$_this4$$awaitT2[0];
              data = _yield$_this4$$awaitT2[1];
              _this4.loading = false;
              if (!err) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              if (Array.isArray(data) && data.length > 0) {
                _this4.errorCodes = _this4.dataCodes.filter(function (item) {
                  return !data.includes(item);
                });
                _this4.successCodes = _this4.dataCodes.filter(function (item) {
                  return data.includes(item);
                });
              } else {
                _this4.errorCodes = _this4.dataCodes;
              }
            case 4:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  }
};